<div class="issue-type">

  <sc-master-detail [selection]="[selected]" [data]="issueTypes" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);"
    (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">
    <form #displayForm="ngForm" class="form">

      @if (workingCopyDetails) {
        <div class="issue-type-details">
          <div class="scrollable">
            <div class="form-box grid">
              <sc-dictionary-field style="grid-column: 1; grid-row: 1;" [model]="workingCopyDetails.name"
                [defaultLabel]="'name'" [labelDictionaryKey]="'tmc-yard.common.name'" [required]="true"
                [maxlength]="255" (dictionaryChanged)="onDictionaryChanged()">
              </sc-dictionary-field>
              <mat-form-field style="grid-column: 1; grid-row: 2;" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.issue-type.delay"></sc-dictionary-label>
                </mat-label>
                <input [(ngModel)]="workingCopyDetails.delay" name="delay" matInput
                  [required]="true" type="number" appPositiveInteger min="0" />
                </mat-form-field>
                <mat-form-field style="grid-column: 1; grid-row: 3;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.issue-type.sortOrder"></sc-dictionary-label>
                  </mat-label>
                  <input [(ngModel)]="workingCopyDetails.sortOrder" name="sortOrder" matInput
                    [required]="false" [maxlength]="10" [minlength]="0" />
                  </mat-form-field>
                </div>
              </div>
            </div>
          }

        </form>

        <ng-template masterDetailToolbar>
          <sc-cancel-button type="button" class="config-changed-button" (click)="cancel()"
          [disabled]="!cancelEnabled"></sc-cancel-button>
          <sc-content-spacer></sc-content-spacer>
          <sc-save-button primary type="button" class="config-changed-button" (click)="save()"
          [disabled]="!saveEnabled"></sc-save-button>
        </ng-template>

      </sc-master-detail>



    </div>
